import { createReducer, on } from '@ngrx/store';
import * as ChangeOrganizationActions from '../actions/change-organization.actions';

export const changeOrganizationFeatureKey = 'changeOrganization';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(ChangeOrganizationActions.changeOrganization, (state) => ({
    ...state,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(ChangeOrganizationActions.changeOrganizationSuccess, (state, action) => ({
    record: action.data.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(ChangeOrganizationActions.changeOrganizationFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(ChangeOrganizationActions.clearChangeOrganizationState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);
